<!--
 * @Author: ext.chenghuan8
 * @Date: 2025-11-28 10:51:47
 * @LastEditors: ext.chenghuan8
 * @LastEditTime: 2025-12-08 15:33:11
 * @Description:
 * @contact_information: ext.chenghuan8@jd.com
-->
<template>
  <div>
    <div class="header-out">
      <div class="logo-box">
        <img src="../../assets/images/common/logo.png" class="logo" />
        颐海企业门户
      </div>
      <header class="header">
        <div class="nav-bar">
          <router-link to="/indexhome">
            <div
              class="nav-text"
              :class="$route.fullPath == '/indexhome' ? 'active' : ''"
            >
              首页
            </div>
          </router-link>
          <router-link to="/center" >
            <div class="nav-text" :class="$route.fullPath == '/center' ? 'active' : ''">个人中心</div>
          </router-link>
        <!-- <router-link to="/headquartersCenter">
          <div class="nav-text" :class="$route.fullPath == '/headquartersCenter' ? 'active' : ''">主管中心</div>
        </router-link> -->
          <router-link to="/assistant">
            <div class="nav-text" :class="$route.fullPath == '/assistant' ? 'active' : ''">AI助手</div>
          </router-link>
        </div>
      </header>
      <div class="info-box">
        <img :src="userInfo.headImg||avatorUrlInit" class="logo" />
        欢迎您!{{ userInfo.name }}
      </div>
      <p class="login-out">
        <span @click="onClickLogin"> {{ $t("tc") }}</span>
      </p>
    </div>
    <div class="height"></div>
  </div>
</template>

<script>
import { session, cookie } from '@/libs/location'
export default {
  name: 'home',
  components: {},
  data () {
    return {
      userInfo: {},
      avatorUrlInit: require('../../assets/images/avator.png')
    }
  },
  computed: {},
  created () {
    console.log(this.$route)
    this.doGetUserInfo()
  },
  methods: {
    onClickLogin () {
      this.$request
        .post('/sso/login/logoutUser', { sessionId: session.getItem('token') })
        .then((res) => {
          let { code } = res.data
          if (code === 'OK') {
            // sessionStorage.clear() // 清除session全部信息
            session.remove('userInfo')
            session.remove('token')
            cookie.removeCookie('token')
            this.$router.push({ name: 'login' })
            // this.childWindow.forEach((item) => {
            //   item.close()
            // })
          }
        })
    },
    // 查询用户基本信息
    doGetUserInfo () {
      this.$request.post('/sso/userAttr/findUserInfo').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          if (data.isUpdatePwd === 1) {
            this.pwdShow = true
          }
          this.userInfo = data
          if (data.remindDay > 0) {
            this.accountShow = true
            this.accountMsg = data.remindMsg
          }
          if (data.skinColor === '#00A8FE' || data.skinColor === '#00A497' || data.skinColor === '#F6A902') {
            this.spanStyle.background = '#CB291D'
          }
          if (data.skinColor === '#CB291D' || data.skinColor === '#F51A4A') {
            this.spanStyle.background = '#00A8FE'
          }
          // this.getCertificates(data)
          session.setItem('userInfo', JSON.stringify(data))
          this.$store.dispatch('doChangeSkin', data.skinColor)
          // 设置 CSS 变量
          if (data.skinColor) {
            document.documentElement.style.setProperty('--primary-color', data.skinColor)
          }
          // this.doGetAppList()
          // this.doGetWorkItemList()
          // this.setTimer(300000)
          this.isAdmin = JSON.parse(session.getItem('userInfo')).id === 0
          this.avatorUrl = data.headImg
          // 设置语言
          if (JSON.parse(session.getItem('language'))) {
            this.$i18n.locale = JSON.parse(session.getItem('language')).languageSign
          } else {
            this.$i18n.locale = data.languageSign
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@homePadding: 0 360px 0 360px;
@background: #ffffff;
@globalColor: #e01313;
@minHeight: 1200px;
@maxWidth: 1200px; //最小的宽度
@maxHeight: 66px; //高度
.height{
   height: @maxHeight;
}
a {
  color: #333333;
  &:hover {
    text-decoration: none;
  }
}

.header-out {
  height: @maxHeight;
  background: linear-gradient( 180deg, #1E1507 0%, #3D2B0E 100%);
  width: 100vw;
  position: fixed;
  top: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  padding: 0 24px;
  .logo-box {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.1rem;
    color: var(--primary-color, #E5A135);
    display: flex;
    align-items: center;
    .logo {
      width: 0.38rem;
      height: 0.2rem;
      margin-right: 10px;
    }
  }
  .header {
    height: @maxHeight;
    display: flex;
    //padding:@homePadding;
    width: @maxWidth;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .nav-barz {
      //margin-right: 554px;
      display: flex;
      font-size: 14px;
      font-weight: 700;
      line-height: @maxHeight;
    }

    .nav-bar {
      font-size: 14px;
      font-weight: 700;
      line-height: @maxHeight;
      display: flex;

      .nav-text {
        // width: 132px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 0.09rem;
        color: #ffffff;
        padding: 0 12px;
        margin: 0 18px;
        height: 36px;
        line-height: 36px;
        text-align: center;
      }
    }
    .active {
      background: var(--primary-color);
      border-radius: 0.09rem;
    }
  }
  .info-box {
    font-family: PingFangSC, PingFang SC;
    font-size: 0.08rem;
    color: #ffffff;
    display: flex;
    align-items: center;
    .logo {
      height: 0.19rem;
      height: 0.19rem;
      margin-right: 10px;
    }
  }
  .login-out {
    margin-left: 16px;
    font-size: 0.08rem;
    color: #ffffff;
  }
}
</style>
